import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { WorkstationCategoryDTO } from '../../workstation-category/dto/workstation-category.dto';
export class WorkstationDTO {


    @ApiProperty()
    @IsOptional()
    workstationId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Unit Id should not be empty" })
    @IsNumber()
    unitId: number;

   @ApiProperty()
   @IsNotEmpty({message: "workstation code should not be empty"})
   workstationCode:string;
   
    @ApiProperty()
    @MaxLength(30, { message: "workstation allows maximum 30 characters" })
    @IsNotEmpty()
    @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"workstation should be only alpha numeric" })
    workstationCategoryId: number;
    // workstationCategory: string;

    @ApiProperty()
    @MaxLength(50, { message: "Workstation  Name allows maximum 50 characters" })
    @IsNotEmpty()
    @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Workstation  Name should be only alpha numeric" })
    workstation: string;

    @ApiProperty()
    @IsNotEmpty({message:"Workstation Capacity should not be empty"})
    workstationUnitCapacity: number;

    @ApiProperty({ type: [WorkstationCategoryDTO]})
    workstationCategoryInfo: WorkstationCategoryDTO;
  
    @ApiProperty()
    @IsOptional()
    workstationCategoryName: string;

    @ApiProperty()
    isActive: boolean;
    createdAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;

    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
}

